import { render, staticRenderFns } from "./yearDataAnalysis.vue?vue&type=template&id=64ed35ed&scoped=true"
import script from "./yearDataAnalysis.vue?vue&type=script&lang=js"
export * from "./yearDataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./yearDataAnalysis.vue?vue&type=style&index=0&id=64ed35ed&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ed35ed",
  null
  
)

export default component.exports